import { kebabCase } from "lodash";

export const getIconSource = (countryName: string) =>
  `/core/img/icons/flags/${kebabCase(countryName)}.svg`;
